import React from "react";
import { Link } from "gatsby";
import Modal from 'react-bootstrap/Modal';

import ContentModule from "../../modules/content_module";
import { PageLinks } from "../../common/page-links";
import ImageModule from "../../modules/image_module";

const TeamCard = ({item}) => {

    const [modalShow, setModalShow] = React.useState(false);
    const [item_id, setItemId] = React.useState("");


    var team_url = `/${PageLinks.teams}/${item.slug}/`;
    
    const ImageRenderList = ({item, imagename}) => {
        let processedImages = JSON.stringify({});
        if (item?.imagetransforms?.image_Transforms) {
            processedImages = item?.imagetransforms?.image_Transforms;
        }
        return (
          <ImageModule ImageSrc={item.image} title={item.title} altText={item.title} imagetransforms={processedImages} renderer="srcSet" imagename={imagename} strapi_id={item.id} />                           
        )
    }

    return (
        <React.Fragment>
            <div className="team-wrap">
                <div className="team-img">
                    {/* <Link to={team_url}>
                        <ImageRenderList item={item} imagename={"teams.image.tile_image"} />
                    </Link> */}
                    <a href={"javascript:;"} onClick={() => {setModalShow(true); setItemId(item.id)}}>
                        <ImageRenderList item={item} imagename={"teams.image.tile_image"} />
                    </a>
                </div>
                <div className="team-content">
                    <h3>
                        <a href={"javascript:;"} onClick={() => {setModalShow(true); setItemId(item.id)}}>{item.name}</a>
                    </h3>
                    <span className="text">{item.designation}</span>
                    <div className="info-wrap">
                        {item.mobile_no && 
                            <a href={`tel:${item.mobile_no}`} className="tel">{item.mobile_no}</a>
                        }
                        {item.email && <Link to={`/${PageLinks.teams}/${item?.slug}/${PageLinks.team_contact}/`} className="email">Email</Link> }
                        {/* <Link to={team_url} className="bio">Bio</Link> */}
                        <a href={"javascript:;"} onClick={() => {setModalShow(true); setItemId(item.id)}} className={`bio`}>Bio</a>
                    </div>
                </div>
            </div>

            {item_id === item.id && 
                <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="lg"
                className="team_modal"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                    <Modal.Header closeButton>
                        {/* <Modal.Title id="contained-modal-title-vcenter">
                            {item.name}
                        </Modal.Title> */}
                    </Modal.Header>
                    <Modal.Body>
                        <div className="team_content col-md-12 col-lg-6">
                            <h3>{item.name}</h3>
                            {item.designation && <h4>{item.designation}</h4>}
                            {item?.content && <ContentModule Content={item?.content} /> }
                        </div>
                        <div className="team_img col-md-12 col-lg-5">
                            <ImageRenderList item={item} imagename={"teams.image.details"} />
                        </div>
                        
                    </Modal.Body>
                </Modal>
            }
        </React.Fragment>
    );
};
export default TeamCard;
